import React from "react";
import { css } from "@emotion/react";
import cn from "classnames";

export const Wrapper: React.FC<React.PropsWithChildren<{
  className?: string;
  context?: { paymentId: string; orderId: string; orderNumber: string };
}>> = props => {
  return (
    <div
      className={cn(props.className, "js-pcp-wrapper")}
      css={css`
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: space-around;

        &.align-start {
          justify-content: flex-start;
        }

        min-height: var(--mh);
      `}
    >
      <div
        css={css`
          display: grid;
          grid-template-rows: 1fr auto;
          flex-grow: 1;
          width: 100%;
        `}
      >
        <div
          css={css`
            display: flex;
            align-items: center;
            flex-direction: column;
            justify-content: flex-start;

            .align-start > * > & {
              justify-content: flex-start;
            }
          `}
        >
          {props.children}
        </div>
      </div>
    </div>
  );
};
